const KEY = "dropit-voice-readback";

export const readbackEnabled = () => localStorage.getItem(KEY) !== "off";
export const setReadbackEnabled = (on) => localStorage.setItem(KEY, on ? "on" : "off");
export const speechSupported = () => typeof window !== "undefined" && "speechSynthesis" in window;

const pickVoice = (lang) => {
  const voices = window.speechSynthesis.getVoices();
  if (!voices.length) return null;
  const want = (lang || navigator.language || "en").toLowerCase();
  const base = want.split("-")[0];
  return voices.find((v) => v.lang.toLowerCase() === want) || voices.find((v) => v.lang.toLowerCase().startsWith(base)) || voices.find((v) => v.default) || null;
};

export const speak = (text, lang) => {
  if (!speechSupported() || !readbackEnabled() || !text) return false;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  const v = pickVoice(lang);
  if (v) { u.voice = v; u.lang = v.lang; } else if (lang) u.lang = lang;
  u.rate = 1;
  window.speechSynthesis.speak(u);
  return true;
};

export const stopSpeaking = () => speechSupported() && window.speechSynthesis.cancel();
export const isSpeaking = () => speechSupported() && window.speechSynthesis.speaking;

export const summarySpeech = (template, rows) => {
  const titles = rows.slice(0, 3).map((r) => r.title || r.task_summary).filter(Boolean);
  const more = rows.length > 3 ? ` and ${rows.length - 3} more` : "";
  const base = (template || "Found {count} jobs: {titles}").replace("{count}", String(rows.length)).replace("{titles}", titles.length ? titles.join(", ") + more : "none");
  const clean = (rows.length === 0 ? base.replace(/:\s*none$/, "") : base).replace(/\{[a-z_]+\}/gi, "").replace(/\s{2,}/g, " ").trim();
  return clean || `Found ${rows.length} jobs`;
};

export const jobSpeech = (d) => {
  const parts = [d.title || d.task_summary];
  if (d.tasks?.length) parts.push(`Tasks: ${d.tasks.join(". ")}.`);
  if (d.hazards?.length) parts.push(`Hazards: ${d.hazards.join(". ")}.`);
  else parts.push("No hazards noted.");
  return parts.join(" ");
};
